module.exports = __webpack_public_path__ + "media/images/about/hero-ef4bb2d39923478763d7cbe161b1a318.jpg";